<!-- Header -->
<h1 class="py-3">
    <i class="fa fa-info-circle d-block pb-3"></i> {{data.title | translate}}
</h1>
<button type="button" class="close-button" (click)="close()">&times;</button>

<!-- Message -->
<p>{{data.message | translate}}</p>

<!-- Buttons -->
<div class="mt-5">
    <button class="button bblg sm-100 my-3" (click)="confirm()">{{ data.confirm | translate}}</button>
    <button class="button bblg sm-100 my-3" (click)="close()" *ngIf="data.cancel">{{ data.cancel | translate}}</button>
</div>